import './line-separator.scss';

const LineSeparator = () => {

  return <div className={'line-separator'}/>
}

export default LineSeparator;